import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HeroSection() {
  return <section className="w-full pt-16 md:pt-24 pb-12 px-4 md:px-8 max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-132">
      <FadeIn delay={100} className="mb-8" data-id="element-133">
        <span className="inline-block border border-amber/50 text-amber px-4 py-1.5 rounded-full text-sm font-lato uppercase tracking-wide bg-amber/5" data-id="element-134">
          Introducing: Resin Without Errors™ — The 7-Day System
        </span>
      </FadeIn>

      <FadeIn delay={200} className="mb-6 max-w-4xl" data-id="element-135">
        <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-cream leading-tight text-balance" data-id="element-136">
          If Your Resin Keeps Coming Out{' '}
          <span className="text-amber" data-id="element-137">Sticky, Bubbly, or Wrong</span> — It's
          Not You. It's <span className="text-amber" data-id="element-138">The Missing System.</span>
        </h1>
      </FadeIn>

      <FadeIn delay={300} className="mb-12 max-w-3xl" data-id="element-139">
        <p className="font-lato text-lg md:text-xl text-cream/80 leading-relaxed text-balance" data-id="element-140">
          From failed batches to sell-ready pieces in 7 days — even if you've
          never worked with resin before.
        </p>
      </FadeIn>

      <FadeIn delay={325} className="mb-8" data-id="element-141">
        <span className="text-amber font-lato text-sm md:text-base tracking-wide" data-id="element-142">
          ✓ Trusted by 2,400+ women across 30+ countries
        </span>
      </FadeIn>

      {/* Main Product Hero Image */}
      <FadeIn delay={350} className="w-[calc(100%+2rem)] -ml-4 md:w-full md:ml-0 max-w-4xl mb-8" data-id="element-143">
        <img src="https://cdn.magicpatterns.com/uploads/fXUGbVPDoS2ikfP2mqz3G3/hf_20260220_035139_2d9eca2c-728c-4770-ba0d-7c75b42a186c.webp" alt="Resin Without Errors — 10-in-1 Premium Program with certificate of excellence, HD videos, step-by-step method, and sell-ready projects" className="w-full rounded-lg md:rounded-xl shadow-2xl shadow-amber/10" style={{
        minHeight: '120%'
      }} data-id="element-144" />
      </FadeIn>

      {/* Before / After Comparison */}
      <FadeIn delay={450} className="w-full max-w-4xl" data-id="element-145">
        <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-146">
          <div className="flex flex-col gap-2" data-id="element-147">
            <div className="relative rounded-xl overflow-hidden" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/spA1B1CvH9FN7R1B19bcrs/ssstik.io_1772228901806-ezgif.com-video-to-gif-converter.gif" alt="Failed resin piece with bubbles and sticky texture" className="w-full object-cover" style={{
              aspectRatio: '4/3',
              minHeight: '180px'
            }} data-id="element-149" />
              <span className="absolute top-3 left-3 bg-red-600/90 text-white text-xs font-lato font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-md" data-id="element-150">
                Before
              </span>
            </div>
            <p className="text-center text-cream/50 text-xs md:text-sm font-lato" data-id="element-151">
              Before Resin Without Errors™
            </p>
          </div>
          <div className="flex flex-col gap-2" data-id="element-152">
            <div className="relative rounded-xl overflow-hidden" data-id="element-153">
              <img src="https://cdn.magicpatterns.com/uploads/iSYC9MCHGiy1ajy96Zh9Ag/FromMainKlickpinCF-PlantBookmarkCoasterDriedFlowerArtworkResinCraftedGiftsforHer-4p5gk968m-ezgif.com-video-to-gif-converter.gif" alt="Beautiful finished resin piece, product-ready" className="w-full object-cover" style={{
              aspectRatio: '4/3',
              minHeight: '180px'
            }} data-id="element-154" />
              <span className="absolute top-3 left-3 bg-green-600/90 text-white text-xs font-lato font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-md" data-id="element-155">
                After
              </span>
            </div>
            <p className="text-center text-cream/50 text-xs md:text-sm font-lato" data-id="element-156">
              After Resin Without Errors™
            </p>
          </div>
        </div>
        <h3 className="font-playfair italic text-2xl md:text-3xl text-amber mt-8 text-center" data-id="element-157">
          The difference a system makes.
        </h3>
      </FadeIn>
    </section>;
}